<template>
  <div>
    <highcharts :options="chartOptions" />
    <div id="svg-chart" hidden />
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';

export default {
  name: 'BarChart',

  components: {
    highcharts: Chart,
  },

  props: {
    titulo: {
      type: String,
      required: true,
    },
    subtitulo: {
      type: String,
      required: false,
      default: '',
    },
    fonte: {
      type: String,
      required: false,
      default: 'Fonte: Sistema Desenvolva',
    },
    legenda: {
      type: String,
      required: false,
      default: undefined,
    },
    descricaoEixoY: {
      type: String,
      required: true,
    },
    categorias: {
      type: Array,
      required: true,
    },
    exibeCategorias: {
      type: Boolean,
      required: false,
      default: true,
    },
    dados: {
      type: Array,
      required: true,
    },
    dataType: {
      type: String,
      required: false,
      default: 'decimal',
    },
    tooltip: {
      type: Object,
      required: false,
      default: undefined,
    },
    fontSizeEixoX: {
      type: String,
      required: false,
      default: '11',
    },
    isGetSvg: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    defaultTooltip() {
      let pointFormat;
      if (this.dataType === 'integer') {
        pointFormat = 'point.y';
      }
      if (this.dataType === 'decimal') {
        pointFormat = 'point.y:.2f';
      }

      return {
        headerFormat: '<span style="padding:2px;"><b>{point.key}</b></span><table>',
        pointFormat:
          '<tr>'
          + '<td style="color:{series.color};padding:0">{series.name}: </td>'
          + `<td style='padding:2px'><span>{${pointFormat}}</span></td>`
          + '</tr>',
        footerFormat: '</table>',
        hideDelay: 100,
        shared: true,
        useHTML: true,
      };
    },

    chartOptions() {
      return {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Roboto;Arial;sans-serif',
          },
          events: {
            render() {
              const chart = this;

              if (chart.fullscreen.isOpen && chart.fullscreenStatus === 'fullscreen: off') {
                chart.fullscreenStatus = 'fullscreen: on';

                chart.update({
                  chart: {
                    marginBottom: window.screen.height * 0.2,
                    height: window.screen.height,
                  },
                  yAxis: {
                    title: {
                      style: {
                        fontSize: '20px',
                      },
                    },
                    labels: {
                      style: {
                        fontSize: '20px',
                      },
                    },
                  },
                  legend: {
                    itemStyle: {
                      fontSize: '20px',
                    },
                  },
                  tooltip: {
                    style: {
                      fontSize: '20px',
                    },
                  },
                });
              }

              if (!chart.fullscreen.isOpen && chart.fullscreenStatus === 'fullscreen: on') {
                chart.fullscreenStatus = 'fullscreen: off';

                chart.update({
                  chart: {
                    marginBottom: chart.initialPlotBottom,
                    height: 400,
                  },
                  yAxis: {
                    title: {
                      style: {
                        fontSize: '12px',
                      },
                    },
                    labels: {
                      style: {
                        fontSize: '11px',
                      },
                    },
                  },
                  legend: {
                    itemStyle: {
                      fontSize: '12px',
                    },
                  },
                  tooltip: {
                    style: {
                      fontSize: '12px',
                    },
                  },
                });
              }
            },
            load() {
              const chart = this;
              chart.initialPlotBottom = chart.plotBottom;
              chart.fullscreenStatus = 'fullscreen: off';
            },
          },
        },
        credits: {
          enabled: true,
        },
        title: {
          text: this.titulo,
        },
        subtitle: {
          text: this.fonte,
        },
        xAxis: {
          type: 'category',
          categories: this.categorias,
          crosshair: true,
          labels: {
            rotation: -45,
            style: {
              display: this.exibeCategorias ? 'block' : 'none',
              fontSize: `${this.fontSizeEixoX}px`,
            },
          },
        },
        yAxis: {
          title: {
            text: `<span style='color:#333333;'><strong>${this.descricaoEixoY}</strong></span>`,
            useHTML: true,
          },
        },
        legend: this.legenda
          ? {
            title: { text: this.legenda },
            labelFormatter() {
              return '';
            },
            useHTML: true,
          }
          : {},
        tooltip: this.tooltip ? { ...this.tooltip, useHTML: true } : this.defaultTooltip,
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                'viewFullscreen',
                'printChart',
                'separator',
                'downloadJPEG',
                'downloadPNG',
                'downloadPDF',
                'downloadSVG',
              ],
            },
          },
        },
        lang: {
          contextButtonTitle: 'Opções do Gráfico',
          decimalPoint: ',',
          viewFullscreen: 'Ver em Tela Cheia',
          printChart: 'Imprimir Gráfico',
          downloadJPEG: 'Baixar como Imagem JPEG',
          downloadPNG: 'Baixar como Imagem PNG',
          downloadPDF: 'Baixar como Documento PDF',
          downloadSVG: 'Baixar como Vetor de Imagem SVG',
          exitFullscreen: 'Sair do modo Tela Cheia',
          loading: 'Carregando...',
          noData: 'Não há dados disponíveis',
        },
        series: this.dados,
      };
    },
  },

  watch: {
    isGetSvg(value) {
      if (value) {
        this.$emit('svg', Highcharts.chart('svg-chart', this.chartOptions).getSVG());
      }
    },
  },
};
</script>
